var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZettablockLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5252_10056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.7179L0 12V0H12V4.7179Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.7179L12 12V0H24V4.7179Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.2821L24 12V24H12V19.2821Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.2821L12 12V24H0V19.2821Z",
    fill: "#263DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5252_10056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZettablockLogoIcon);
export default __webpack_public_path__ + "static/media/zettablock-logo-icon.5bd74031d423beb54963d06e18c10dd9.svg";
export { ForwardRef as ReactComponent };